import { useTranslation } from 'react-i18next';
import { useTier } from '../hooks/useTier';
import { UpgradeButton } from './UpgradeButton';

export function TrialExpiryBanner() {
  const { t } = useTranslation();
  const { tier, trialDaysRemaining, isReadOnly, monetizationEnabled } = useTier();

  if (!monetizationEnabled || isReadOnly) return null;
  if (tier !== 'trial' || trialDaysRemaining === null || trialDaysRemaining > 2) return null;

  return (
    <div className="trial-expiry-banner">
      <span>
        {t('app.trialExpiryBanner.message', { count: trialDaysRemaining })}
      </span>
      <UpgradeButton label={t('common.upgrade')} />
    </div>
  );
}
